import Service from '@/helpers/service'

export default {

    get(params) {
        return Service().get('StorageType', {params});
    }, 
    show(id) {
        return Service().get('StorageType/show/'+id);
    },    
    create(params) {
        return Service().post('StorageType/create', params);
    },
    update(id, params) {
        return Service().post('StorageType/update/'+id, params);
    },
    delete(id) {
        return Service().post('StorageType/delete/'+id);
    }
}